export * from './country';
export * from './units';

export const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

export const goalOptions = [
  {
    label: 'Appearance',
    value: 'Appearance',
  },
  {
    label: 'Health',
    value: 'Health',
  },
  {
    label: 'Athletic Performance',
    value: 'Athletic Performance',
  },
  {
    label: 'Lifestyle Performance',
    value: 'Lifestyle Performance',
  },
  {
    label: 'Injury Prevention/Rehabilitation',
    value: 'Injury Prevention/Rehabilitation',
  },
];
export const appearanceOptions = [
  {
    value: 'I want to lose weight.',
    label: 'I want to lose weight.',
  },
  {
    value: 'I want to build lean muscle mass.',
    label: 'I want to build lean muscle mass.',
  },
  {
    value: 'I want to bulk up.',
    label: 'I want to bulk up.',
  },
];

export const lifestylePerformanceOptions = [
  {
    value: 'I want to perform better at work and home',
    label: 'I want to perform better at work and home',
  },
  {
    value: 'I want be more physically active with my friends and family',
    label: 'I want be more physically active with my friends and family',
  },
  {
    value: 'I want to make fitness more varied, fun, and enjoyable',
    label: 'I want to make fitness more varied, fun, and enjoyable',
  },
];

export const businessTypeOptions = [
  {
    value: 'Self-Employed Fitness Professional',
    label: 'Self-Employed Fitness Professional',
  },
  {
    value: 'Fitness Professional Employed by Fitness Facility',
    label: 'Fitness Professional Employed by Fitness Facility',
  },
  {
    value: 'Studio/Club Owner',
    label: 'Studio/Club Owner',
  },
  {
    value: 'Other',
    label: 'Other',
  },
];

export const userTypeOptions = [
  {
    value: 'Personal Trainer',
    label: 'Personal Trainer',
  },
  {
    value: 'Group Fitness Instructor',
    label: 'Group Fitness Instructor',
  },
  {
    value: 'Yoga/Pilates Instructor',
    label: 'Yoga/Pilates Instructor',
  },
  {
    value: 'Personal Training/Wellness Director',
    label: 'Personal Training/Wellness Director',
  },
  {
    value: 'Wellness/Health Coach',
    label: 'Wellness/Health Coach',
  },
  {
    value: 'Strength & Conditioning Coach/Athletic Trainer',
    label: 'Strength & Conditioning Coach/Athletic Trainer',
  },
  {
    value: 'Nutritionist/Dietician',
    label: 'Nutritionist/Dietician',
  },
  {
    value: 'Other',
    label: 'Other',
  },
];

export const clientCountOptions = [
  {
    value: '<16',
    label: '<16',
  },
  {
    value: '16-50',
    label: '16-50',
  },
  {
    value: '50-200',
    label: '50-200',
  },
  {
    value: '>200',
    label: '>200',
  },
];

export const healthOptions = [
  {
    value: 'I want to feel great.',
    label: 'I want to feel great.',
  },
  {
    value: 'I want to decrease my risk of disease.',
    label: 'I want to decrease my risk of disease.',
  },
  {
    value: 'I want to combat a pre-existing condition.',
    label: 'I want to combat a pre-existing condition.',
  },
];

export const athleticPerformanceOptions = [
  {
    value: 'I want to get stronger',
    label: 'I want to get stronger',
  },
  {
    value: 'I want to improve cardio and endurance',
    label: 'I want to improve cardio and endurance',
  },
  {
    value: 'I want to improve my mobility and flexibility',
    label: 'I want to improve my mobility and flexibility',
  },
];

export const rehabilitationOptions = [
  {
    value: 'I want to decrease my risk of future injuries',
    label: 'I want to decrease my risk of future injuries',
  },
  {
    value: 'I want to rehab an existing injury or injuries',
    label: 'I want to rehab an existing injury or injuries',
  },
];

export const secondaryGoalOptions = {
  Appearance: appearanceOptions,
  Health: healthOptions,
  'Athletic Performance': athleticPerformanceOptions,
  'Lifestyle Performance': lifestylePerformanceOptions,
  'Injury Prevention/Rehabilitation': rehabilitationOptions,
};
